import { useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { renderInputBranch } from "components/form/CommonInputs";
import { useBranchesContext } from "api/settings/branches/BranchesProvider";
import { DELIVERY_NOTE_FORM_LABELS } from "constants/forms";
import { formatCompanyAddress } from "utils/deliveryNoteHelper";
import PartyBlock from "./PartyBlock";

const IssuerBlock = ({
  control,
  register,
  errors,
  watch,
  setValue,
  isSubmitted,
  setCode,
  setStatus,
  onImageChange,
  resolveImage,
}) => {
  const { fetchBranches, branches } = useBranchesContext();

  useEffect(() => {
    fetchBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setIssuerCompany = (name, selection) => {
    setValue(name, selection, { shouldValidate: isSubmitted });
    const branch = branches?.find((elm) => elm.id === selection?.[0]?.value);
    setValue(
      "issuer_address",
      branch
        ? formatCompanyAddress({
            address: branch.address,
            postalCode: branch.address_postal_code,
            city: branch.address_city,
          })
        : ""
    );
    setValue("issuer_siret", branch?.insee_code || "");
    setValue("issuer_phone", branch?.phone_number || "");
  };

  return (
    <PartyBlock
      prefix="issuer"
      title={
        <FormattedMessage
          id="delivery_note_issuer_block"
          defaultMessage="Émetteur"
        />
      }
      logoValue={resolveImage(watch("issuer_logo_file_id"))}
      onLogoChange={(file) => onImageChange("issuer_logo_file_id", file)}
      companyField={renderInputBranch({
        control,
        register,
        branches,
        name: "issuer_company",
        label: DELIVERY_NOTE_FORM_LABELS.company,
        value: watch("issuer_company"),
        setValue: setIssuerCompany,
        errors: errors.issuer_company,
      })}
      control={control}
      register={register}
      setCode={setCode}
      setStatus={setStatus}
    />
  );
};

IssuerBlock.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool,
  setCode: PropTypes.func,
  setStatus: PropTypes.func,
  onImageChange: PropTypes.func.isRequired,
  resolveImage: PropTypes.func.isRequired,
};

export default IssuerBlock;
